import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { DiagnosticsPanelProps } from './DiagnosticsPanel';

const DiagnosticsPanel = () => import(/* webpackChunkName: "4-feat-diagnostics-panel" */ './DiagnosticsPanel');

const LoadableDiagnosticsPanel: ComponentType<DiagnosticsPanelProps> = lazyLoadOnRender({ loader: DiagnosticsPanel });
export default LoadableDiagnosticsPanel;
